<template>
  <div class="container-fluid">
    <PainelAcesso>
      <template #cabecalho >
        <div class="modal-title text-center">
          <div class="d-flex justify-content-center ">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12">
              <h5 class="textos text-left text-bold">
                Altere sua senha
              </h5>
              <h6 class="text-left">
                <span class="textos">É necessário alterar a senha no primeiro acesso</span>
              </h6>
            </div>
          </div>
        </div>
      </template>
      <template #corpo>
        <form class="mt-2">
          <div class="form-row justify-content-center">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <label for="inputSenhaAtual" class="required">Senha Atual</label>
              <input type="password" v-model="formulario.senha_atual" @keyup="eventoLoginTeclaEnter" @input="limparListaErros" :disabled="flagsDeControle.manipulandoDados.status" autocomplete="off" class="form-control" id="inputSenhaAtual">
              <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.senha_atual}}</div>
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <label for="inputNovaSenha" class="required">Nova Senha</label>
              <input type="password" v-model="formulario.nova_senha" @keyup="eventoLoginTeclaEnter" @input="validarSenha()" :disabled="flagsDeControle.manipulandoDados.status" autocomplete="off" class="form-control" id="inputNovaSenha">
              <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.nova_senha}}</div>
            </div>
          </div>
          <div class="d-flex justify-content-center ">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <div id="password-feedback" class="d-flex flex-wrap flex-column">
                <span><i :class="{'fa fa-check text-success': flagsValidacao.isPasswordLengthValid, 'fa fa-times text-danger': !flagsValidacao.isPasswordLengthValid}" aria-hidden="true"></i> Pelo menos 8 caracteres</span>
                <span><i :class="{'fa fa-check text-success': flagsValidacao.isPasswordUppercaseValid, 'fa fa-times text-danger': !flagsValidacao.isPasswordUppercaseValid}" aria-hidden="true"></i> Pelo menos uma letra maiúscula</span>
                <span><i :class="{'fa fa-check text-success': flagsValidacao.isPasswordNumberValid, 'fa fa-times text-danger': !flagsValidacao.isPasswordNumberValid}" aria-hidden="true"></i> Pelo menos um numero</span>
              </div>
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <label for="inputConfirmarSenha" class="required">Confirmar Senha</label>
              <input type="password" v-model="formulario.confirmacao_senha" @keyup="eventoLoginTeclaEnter" @input="limparListaErros" :disabled="flagsDeControle.manipulandoDados.status" autocomplete="off" class="form-control" id="inputConfirmarSenha">
              <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.confirmacao_senha}}</div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button class="col-xl-8 col-lg-8 col-md-12 col-sm-12" variant="btn btn-verde btn-block" :disabled="flagsDeControle.manipulandoDados.status" @click="alterarSenha()">Salvar</b-button>
          </div>
          <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex justify-content-center align-items-center">
            <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
        </form>
      </template>
    </PainelAcesso>
  </div>
</template>

<script>
import AlteracaoSenhaLoginLite from './js/alteracaoSenhaLoginLite'
export default AlteracaoSenhaLoginLite
</script>

<style scoped>
@import "./scss/login.scss";
</style>
